<template>
    <div class="service-container">
        <div class="container">
            <div class="banner"></div>
            <div class="status" v-if="content && content.awardStatus === 20">
                <div class="line"></div>
                <div class="status-desc">已开启专线服务</div>
                <div class="line"></div>
            </div>
            <div class="status-hodler" v-else></div>
            <div class="cell-phone">
                <div class="phone-icon"></div>
                <div class="phone-title">客服电话</div>
                <br />
                <div
                    class="phone-number"
                    :class="content && content.awardStatus === 20 ? 'phone-status' : ''"
                    @click="callService"
                >
                    400-184-8888
                </div>
            </div>
            <div class="cell-phone-time">
                <div class="time-icon"></div>
                <div class="time-title">人工客服服务时间</div>
                <br />
                <div class="time-number">8:00-20:00</div>
            </div>
            <div class="tips">友情提示：请使用当前账号绑定手机号码联系我们</div>
            <div class="btn" v-if="content && content.awardStatus === 0" @click="skipOuter()">
                {{ statusDesc().desc }}
            </div>
            <div class="btn-bottom-txt" v-if="content && content.awardStatus === 0">
                {{ content.requireLevel }}及以上用户专项
            </div>
        </div>
        <Dialog
            :show="showDialog"
            title="前往首页申请借款，成交后即可激活成长权益"
            lefttxt="再看看"
            righttxt="去首页"
            @giveupBtn="giveupBtn"
            @continueBtn="continueBtn"
        />
        <Dialog1
            :show="showUpdataDialog"
            title="做任务可以增加活力值哦！"
            lefttxt="再看看"
            righttxt="去做任务"
            @giveupBtn="giveupTask"
            @continueBtn="doSomeTask"
        />
    </div>
</template>
<script>
import homemixin from '@common/js/mixin';
import Dialog from '../../componets/birthday/homeDialog';
import Dialog1 from '../../componets/birthday/homeDialog';

export default {
    name: 'service',
    components: { Dialog, Dialog1 },
    mixins: [homemixin],
    data() {
        return {
            showDialog: false,
            showUpdataDialog: false,
            content: null,
            titleBar: {
                fullScreen: 2,
                visible: 1,
                leftView: [
                    {
                        action: 'back',
                        color: '#000000',
                        icon: 'ppdwebui://resource/drawable/nav_back',
                        callback: this.goClose
                    }
                ],
                titleView: {
                    text: 'VIP客服',
                    color: '#000000'
                },
                rightView: []
            }
        };
    },
    created() {
        if (window.PPDWebUI.os.inApp) {
            window.PPDWebUI.CommonService.setNavigation(this.titleBar);
        }
        this.getCustomerPageInfo();
    },
    methods: {
        // goBacktoHome() {
        //     this.$router.push('/');
        // },
        callService() {
            if (this.content.awardStatus === 20) {
                location.href = `tel:400-184-8888`;
                this.POINT('h5_clk', {
                    tgt_event_id: 'h5_ACT_button',
                    tgt_name: 'h5_ACT_客服专线',
                    page: 'super-客服专线',
                    param1: `${this.content.score}`,
                    param3: '客服电话'
                });
            }
        },
        giveupBtn() {
            this.showDialog = false;
        },
        continueBtn() {
            this.goHome();
        },
        doSomeTask() {
            localStorage.setItem('updata', 'true');
            this.goClose();
        },
        giveupTask() {
            this.showUpdataDialog = false;
        },
        skipOuter() {
            if (this.content.isOldCustomer) {
                // localStorage.setItem('updata', 'true');
                // this.$router.replace({
                //     path: '/'
                // });
                // this.goClose();
                this.showUpdataDialog = true;
            } else {
                this.showDialog = true;
            }
            this.POINT('h5_clk', {
                tgt_event_id: 'h5_ACT_button',
                tgt_name: 'h5_ACT_客服专线',
                page: 'super-客服专线',
                param1: `${this.content.score}`,
                param3: `${this.statusDesc().desc}`
            });
        },
        statusDesc() {
            if (this.content.isOldCustomer) {
                return {
                    desc: '去升级',
                    class: 1
                };
            } else {
                return {
                    desc: '去激活',
                    class: 1
                };
            }
        },
        async getCustomerPageInfo() {
            const { Result, Content } = await this.$http.getCustomerPageInfo();
            if (Result === 200) {
                console.log(Content);
                this.content = Content;
            }
            this.POINT('h5_element_imp', {
                tgt_event_id: 'h5_ACT_imp',
                tgt_name: 'h5_ACT_客服专线',
                page: 'super-客服专线',
                param1: `${this.content.score}`,
                param3: `${this.content.awardStatus === 0 ? this.statusDesc().desc : '客服电话'}`
            });
        }
    }
};
</script>
<style lang="less" scoped>
@import '~@common/style/common.less';
.service-container {
    height: 100%;
    width: 100%;
    overflow: hidden;
    overflow-y: auto;
    .container {
        width: 100%;
        .banner {
            .backgroundImage(375px, 140px, '~@assets/img/service_banner.png');
        }
        .status {
            display: flex;
            align-content: center;
            align-items: center;
            flex-direction: row;
            justify-content: center;
            margin-top: 20px;
            .line {
                background-color: #e3ba8a;
                width: 18px;
                height: 2px;
                display: inline-block;
                margin-left: 5px;
                margin-right: 5px;
            }
            .status-desc {
                display: inline-block;
                .f-16-bold();
                color: rgba(41, 39, 56, 1);
                line-height: 18px;
            }
        }
        .status-hodler {
            width: 100%;
            height: 10px;
        }
        .cell-phone {
            margin: 30px;
            margin-top: 20px;
            position: relative;
            .phone-icon {
                display: inline-block;
                .backgroundImage(25px, 25px, '~@assets/img/service_phone.png');
            }
            .phone-title {
                position: absolute;
                display: inline-block;
                .f-14-bold();
                top: 0px;
                left: 30px;

                color: rgba(41, 39, 56, 1);
                line-height: 18px;
            }

            .phone-number {
                position: absolute;
                display: inline-block;
                .f-14();
                top: 18px;
                left: 30px;
                color: rgba(41, 39, 56, 1);
                line-height: 18px;
            }
            .phone-status {
                color: #2199ff;
                text-decoration: underline;
            }
        }
        .cell-phone-time {
            margin: 30px;
            margin-top: 37px;
            position: relative;
            .time-icon {
                display: inline-block;
                .backgroundImage(25px, 25px, '~@assets/img/service_time.png');
            }
            .time-title {
                position: absolute;
                display: inline-block;
                .f-14-bold();
                top: 0px;
                left: 30px;
                text-align: center;
                color: rgba(41, 39, 56, 1);
                line-height: 18px;
            }
            .time-number {
                position: absolute;
                display: inline-block;
                .f-14();
                top: 18px;
                left: 30px;
                color: rgba(41, 39, 56, 1);
                line-height: 18px;
            }
        }
        .tips {
            font-size: 12px;
            font-family: FZLTHThin--GB1-4-YS, FZLTHThin--GB1-4;
            font-weight: normal;
            color: rgba(41, 39, 56, 1);
            line-height: 20px;
            margin: auto;
            padding-left: 10px;
            text-align: center;
        }

        .btn {
            .backgroundImage(212px, 40px, '~@assets/img/birthday_btn.png');
            margin: auto;
            margin-top: 37px;
            color: #ece0cf;
            .f-16-bold();
            text-align: center;
            line-height: 40px;
        }
        .btn-bottom-txt {
            .f-12();
            color: rgba(164, 167, 179, 1);
            line-height: 12px;
            margin: auto;
            margin-top: 18px;
            text-align: center;
        }
    }
}
</style>
